import { useEffect, useState } from "react";
import '@cds/core/select/register.js';
import '@cds/core/toggle/register.js';
import '@cds/core/input/register.js';
import '@cds/core/radio/register.js';
import '@cds/core/divider/register.js';
import '@cds/core/forms/register.js';
import { CdsInput } from '@cds/react/input';
import { CdsSelect } from '@cds/react/select';
import { CdsCheckbox } from '@cds/react/checkbox';
import { CdsRadio } from '@cds/react/radio';
import { CdsFormGroup } from '@cds/react/forms';
import { CdsIcon } from '@cds/react/icon';
import { CdsDivider } from '@cds/react/divider';
import { CdsButton } from '@cds/react/button';
import "./Option.css";
import '@cds/core/global.css';
import ReactGA from 'react-ga4';
import Coffee from "../coffee";
import {
  hostSpecSchema,
  genDataStoreSchema,
  genVdsPortGroupSchema,
  mapVmNicToVds,
} from "../schemas";
import { exportJSON } from "../utils/exportJSON";
import {
  dataStoreSpecInputs,
  noOfHostToSelectOptions,
  nsxTClusterSpecInputs,
} from "../utils/inputs";

const eventTrack = (category, action, label) => {
  console.log("GA event:", category, ":", action, ":", label);
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  })
}

export default function Option1() {
  const [data, setData] = useState({
    domainName: "",
    vcenterSpec: {
      name: "",
      networkDetailsSpec: {
        ipAddress: "",
        dnsName: "",
        gateway: "",
        subnetMask: "",
      },
      rootPassword: "",
      datacenterName: "",
      vmSize: "medium",
    },
    computeSpec: {
      clusterSpecs: [
        {
          name: "",
          hostSpecs: [],
          datastoreSpec: {},
          networkSpec: {
            vdsSpecs: [],
            nsxClusterSpec: {
              nsxTClusterSpec: {
                geneveVlanId: "",
              },
            },
          },
        },
      ],
    },
    nsxTSpec: {
      nsxManagerSpecs: [
        {
          name: "",
          networkDetailsSpec: {
            ipAddress: "",
            dnsName: "",
            gateway: "",
            subnetMask: "",
          },
        },
        {
          name: "",
          networkDetailsSpec: {
            ipAddress: "",
            dnsName: "",
            gateway: "",
            subnetMask: "",
          },
        },
        {
          name: "",
          networkDetailsSpec: {
            ipAddress: "",
            dnsName: "",
            gateway: "",
            subnetMask: "",
          },
        },
      ],
      vip: "",
      vipFqdn: "",
      licenseKey: "",
      nsxManagerAdminPassword: "",
      formFactor: "large",
    },
  });

  const [isClusterImage, setIsClusterImage] = useState(false);
  const [dataStoreType, setDataStoreType] = useState("");
  const [noOfHostToSelectStartsWith, setNoOfHostToSelectStartsWith] =
    useState(2);
  const [noOfVmNics, setNoOfVmNics] = useState([2, 4, 6]);
  const [nsxClusterType, setNsxClusterType] = useState("DHCP");
  const [isNewNsxTSpec, setIsNewNsxTSpec] = useState("Not Selected");

  const onDataStoreSpecChange = (event) => {
    const key = event.target.name;
    let value = event.target.value;
    const datastoreSpec = { ...data.computeSpec.clusterSpecs[0].datastoreSpec };
    let hostSpecs = [...data.computeSpec.clusterSpecs[0].hostSpecs];
    const dataStore = Object.keys(datastoreSpec)[0];

    if (dataStoreType === "vmfs") {
      datastoreSpec[dataStore].fcSpec[0][key] = value;
    } else if (dataStoreType === "nfs") {
      if (key === "datastoreName") {
        datastoreSpec[dataStore][0][key] = value;
      } else if (key === "serverName") {
        datastoreSpec[dataStore][0].nasVolume[key][0] = value;
      } else if (key === "path") {
        datastoreSpec[dataStore][0].nasVolume[key] = value;
      }
    } else if (dataStoreType === "vvol") {
      if (key === "name") {
        datastoreSpec[dataStore][0][key] = value;
      } else {
        datastoreSpec[dataStore][0].vasaProviderSpec[key] = value;
      }
    } else if (dataStoreType === "vsan") {
      if (key === "failuresToTolerate") {
        hostSpecs = [];
        value = parseInt(value);
        setNoOfHostToSelectStartsWith(value === 2 ? 5 : 3);
      }
      datastoreSpec[dataStore][key] = value;
    }

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          { ...data.computeSpec.clusterSpecs[0], hostSpecs, datastoreSpec },
        ],
      },
    });
  };

  const onHostSpecChange = (key, value, index) => {
    const hostSpecs = [...data.computeSpec.clusterSpecs[0].hostSpecs];

    if (key === "id") {
      hostSpecs[index] = {
        ...hostSpecs[index],
        [key]: value,
      };
    } else if (key === "licenseKey") {
      hostSpecs.forEach((hostSpec) => {
        hostSpec[key] = value;
      });
    } else if (key === "vmNics") {
      hostSpecs.forEach((hostSpec) => {
        hostSpec.hostNetworkSpec[key] = value;
      });
    }

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            hostSpecs,
          },
        ],
      },
    });
  };

  const onVdsSpecChange = (index, key, value) => {
    const vdsSpecs = [...data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs];
    const vdsSpec = {
      ...vdsSpecs[index],
    };
    if (vdsSpec.portGroupSpecs) {
      vdsSpec.portGroupSpecs = vdsSpec.portGroupSpecs.filter(
        (v) => v.transportType !== "PUBLIC"
      );
    }

    let doFilterOther = false;
    if (key === "name") {
      vdsSpec[key] = value;
    } else if (key === "isUsedByNsxt") {
      const doDelete = vdsSpec[key];
      if (doDelete) {
        delete vdsSpec[key];
      } else {
        vdsSpecs.forEach((v) => {
          delete v[key];
        });
        vdsSpec[key] = value;
      }
    } else if (key === "portGroupSpecs") {
      // should we filter or should we add
      const doFilter =
        vdsSpec[key] &&
        vdsSpec[key].some((v) => v.transportType === value.transportType);

      if (doFilter) {
        vdsSpec[key] = vdsSpec[key].filter(
          (v) => v.transportType !== value.transportType
        );
      } else {
        doFilterOther = true;
        if (vdsSpec[key]) {
          vdsSpec[key].push(value);
        } else {
          vdsSpec[key] = [value];
            }
          }
    }

    vdsSpecs[index] = vdsSpec;
    vdsSpecs.forEach((vdsSpec, i) => {
      // remove other transportType when select one
      if (doFilterOther && i !== index) {
        if (vdsSpec.portGroupSpecs) {
          vdsSpec.portGroupSpecs = vdsSpec.portGroupSpecs.filter(
            (v) => v.transportType !== value.transportType
          );
        }
      }
      // add public if empty
      if (!vdsSpec.isUsedByNsxt) {
        if (!vdsSpec.portGroupSpecs || vdsSpec.portGroupSpecs.length === 0) {
          vdsSpec.portGroupSpecs = [
            {
              name: `sfo-w01-cl01-vds0${i + 1}-pg-public`,
              transportType: "PUBLIC",
            },
          ];
        }
      }
      // remove portgroup if empty
      if (vdsSpec.portGroupSpecs && vdsSpec.portGroupSpecs.length === 0) {
        delete vdsSpec.portGroupSpecs;
      }
    });

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            networkSpec: {
              ...data.computeSpec.clusterSpecs[0].networkSpec,
              vdsSpecs,
            },
          },
        ],
      },
    });
  };

  const onPortGroupNameChange = (vdsIndex, portGroupIndex, value) => {
    const vdsSpecs = [...data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs];
    const vdsSpec = {
      ...vdsSpecs[vdsIndex],
    };
    vdsSpec.portGroupSpecs[portGroupIndex].name = value;
    vdsSpecs[vdsIndex] = vdsSpec;

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            networkSpec: {
              ...data.computeSpec.clusterSpecs[0].networkSpec,
              vdsSpecs,
            },
          },
        ],
      },
    });
  };

  const onNsxClusterSpecChange = (event) => {
    const key = event.target.name;
    let value = event.target.value;
    const nsxTClusterSpec = {
      ...data.computeSpec.clusterSpecs[0].networkSpec.nsxClusterSpec
        .nsxTClusterSpec,
    };

    if (key === "geneveVlanId") {
      nsxTClusterSpec[key] = parseInt(value);
    } else if (key === "name") {
      nsxTClusterSpec.ipAddressPoolSpec.name = value;
    } else if (key.includes("start") || key.includes("end")) {
      const modKey = key.split("_")[0];
      const index = key.split("_")[1];
      nsxTClusterSpec.ipAddressPoolSpec.subnets[0].ipAddressPoolRanges[index][
        modKey
      ] = value;
    } else if (key === "cidr") {
      nsxTClusterSpec.ipAddressPoolSpec.subnets[0].cidr = value;
    } else if (key === "gateway") {
      nsxTClusterSpec.ipAddressPoolSpec.subnets[0].gateway = value;
    }

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            networkSpec: {
              ...data.computeSpec.clusterSpecs[0].networkSpec,
              nsxClusterSpec: {
                ...data.computeSpec.clusterSpecs[0].networkSpec.nsxClusterSpec,
                nsxTClusterSpec,
              },
            },
          },
        ],
      },
    });
  };


  const onNsxManagerSpecChange = (index, key, value) => {
    const nsxManagerSpecs = [...data.nsxTSpec.nsxManagerSpecs];
    const modNsxManagerSpec = { ...nsxManagerSpecs[index] };
    if (key === "name") {
      modNsxManagerSpec[key] = value;
    } else {
      modNsxManagerSpec.networkDetailsSpec[key] = value;
    }
    nsxManagerSpecs[index] = modNsxManagerSpec;

    setData({
      ...data,
      nsxTSpec: {
        ...data.nsxTSpec,
        nsxManagerSpecs,
      },
    });
  };

  useEffect(() => {
    let clusterSpec = {
      ...data.computeSpec.clusterSpecs[0],
    };

    if (isClusterImage === true) {
      clusterSpec = {
        ...clusterSpec,
        clusterImageId: "",
      };
    } else {
      delete clusterSpec.clusterImageId;
      if (clusterSpec.hostSpecs.length === 2) {
        clusterSpec.hostSpecs = [];
      }
    }

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...clusterSpec,
          },
        ],
      },
    });
  }, [isClusterImage]);

  useEffect(() => {
    if (dataStoreType === "vsan") {
      setNoOfHostToSelectStartsWith(3);
    } else {
      if (noOfHostToSelectStartsWith !== 2) {
        setNoOfHostToSelectStartsWith(2);
      }
    }
    const datastoreSpec = genDataStoreSchema(dataStoreType);

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            datastoreSpec,
          },
        ],
      },
    });
  }, [dataStoreType]);

  useEffect(() => {
    const nsxClusterSpec = {
      nsxTClusterSpec: {
        geneveVlanId: "",
      },
    };

    if (nsxClusterType === "static_new") {
      nsxClusterSpec.nsxTClusterSpec = {
        geneveVlanId: "",
        ipAddressPoolSpec: {
          name: "",
          subnets: [
            {
              ipAddressPoolRanges: [
                {
                  start: "",
                  end: "",
                },
                /* {
                   start: "10.0.11.80",
                   end: "10.0.11.150",
                 }, */
              ],
              cidr: "",
              gateway: "",
            },
          ],
        },
      };
    } else if (nsxClusterType === "static_existing") {
      nsxClusterSpec.nsxTClusterSpec = {
        geneveVlanId: "",
        ipAddressPoolSpec: {
          name: "",
        },
      };
    }

    setData({
      ...data,
      computeSpec: {
        ...data.computeSpec,
        clusterSpecs: [
          {
            ...data.computeSpec.clusterSpecs[0],
            networkSpec: {
              ...data.computeSpec.clusterSpecs[0].networkSpec,
              nsxClusterSpec,
            },
          },
        ],
      },
    });
  }, [nsxClusterType]);


  return (
    <form>
    <div className="Option">
      <div className="option_input_section">
        <section className="option_section">
          <span>{`Domain Configuration`}</span>
          <br />
          <div className="option_clusterspec_div">
          <cds-form-group layout="horizontal" validate>
            <cds-input layout="horizontal" control-width="shrink">
              <label>Domain Name</label>
              <input placeholder="sfo-w01"
                required
                value={data.domainName}
                onChange={(event) =>
                  setData({ ...data, domainName: event.target.value })
                }
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-input layout="horizontal" control-width="shrink">
              <label>Datacenter Name</label>
              <input placeholder="sfo-w01-dc01"
              required
                value={data.vcenterSpec.datacenterName}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      datacenterName: event.target.value,
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            </cds-form-group>
          </div>
        </section>

{/* computeSpec */}
      <section className="option_section">
          <span>{`Cluster Configuration`}</span>
          <br />
          <div cds-layout="vertical gap:lg">
          <cds-form-group layout="horizontal" validate>
          <cds-input layout="horizontal" control-width="shrink">
              <label>Cluster Name</label>
              <input placeholder="sfo-w01-cl01"
              required
              value={data.computeSpec.clusterSpecs[0].name}
              onChange={(event) => {
                setData({
                  ...data,
                  computeSpec: {
                    ...data.computeSpec,
                    clusterSpecs: [
                      {
                        ...data.computeSpec.clusterSpecs[0],
                        name: event.target.value,
                      },
                    ],
                  },
                });
              }}
            />
            <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-select control-width="shrink">
              <label>{`Use a Cluster Image?`}</label>
              <select
              required
                value={isClusterImage}
                onChange={(event) => {
                  setIsClusterImage(
                    event.target.value === "true" ? true : false
                  );
                }}
              >
                <option value={true} selected={isClusterImage}>
                  Yes
                </option>
                <option value={false} selected={isClusterImage}>
                  No
                </option>
                <br />
              </select>
            </cds-select>
            {isClusterImage && (
              <cds-input layout="horizontal" control-width="shrink" validate>
                <label>Cluster Image ID</label>
                <input placeholder="55594e6f-6b2c-481b-8bcc-18d1f9d2b9f6"
                required
                onChange={(event) => {
                  setData({
                    ...data,
                    computeSpec: {
                      ...data.computeSpec,
                      clusterSpecs: [
                        {
                          ...data.computeSpec.clusterSpecs[0],
                          clusterImageId: event.target.value,
                        },
                      ],
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
              </cds-input>
            )}
            </cds-form-group>
          </div>
        </section>


        {/* vcenterSpec */}
        <section className="option_section">
          <span>{`vCenter Configuration`}</span>
          <br />
          <div className="row">
            <div cds-layout="vertical gap:lg" className="column">
            <cds-form-group layout="horizontal" validate>
            <cds-input layout="horizontal" control-width="shrink">
              <label>IP Address</label>
              <input placeholder="172.16.11.64"
              required
              pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
                value={data.vcenterSpec.networkDetailsSpec.ipAddress}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      networkDetailsSpec: {
                        ...data.vcenterSpec.networkDetailsSpec,
                        ipAddress: event.target.value,
                      },
                    },
                  });
                }}
              />
              <cds-control-message error="patternMismatch">required</cds-control-message>
            </cds-input>
            <cds-input layout="horizontal" control-width="shrink">
              <label>FQDN</label>
              <input placeholder="sfo-w01-vc01.sfo.rainpole.io"
                required
                value={data.vcenterSpec.networkDetailsSpec.dnsName}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      networkDetailsSpec: {
                        ...data.vcenterSpec.networkDetailsSpec,
                        dnsName: event.target.value,
                      },
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-input layout="horizontal" control-width="shrink">
              <label>Gateway</label>
              <input placeholder="172.16.11.1"
              required
              pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
                value={data.vcenterSpec.networkDetailsSpec.gateway}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      networkDetailsSpec: {
                        ...data.vcenterSpec.networkDetailsSpec,
                        gateway: event.target.value,
                      },
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-input layout="horizontal" control-width="shrink">
              <label>Subnet Mask</label>
              <input placeholder="255.255.255.0"
              required
              pattern="^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))"
                value={data.vcenterSpec.networkDetailsSpec.subnetMask}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      networkDetailsSpec: {
                        ...data.vcenterSpec.networkDetailsSpec,
                        subnetMask: event.target.value,
                      },
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            </cds-form-group>
            </div>
            <cds-divider orientation="vertical"></cds-divider>&nbsp;&nbsp;&nbsp;
            <div cds-layout="vertical gap:lg" className="column">
            <cds-form-group layout="horizontal" validate>
            <cds-input layout="horizontal" control-width="shrink">
              <label>vCenter VM Name</label>
              <input placeholder="sfo-w01-vc01"
              required
                value={data.vcenterSpec.name}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      name: event.target.value,
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-input layout="horizontal" control-width="shrink">
              <label>Root Password</label>
              <input placeholder="vcenter_server_root_password"
              required
                value={data.vcenterSpec.rootPassword}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      rootPassword: event.target.value,
                    },
                  });
                }}
              />
              <cds-control-message error="valueMissing">required</cds-control-message>
            </cds-input>
            <cds-select control-width="shrink">
              <label>VM Size </label>
              <select
                value={data.vcenterSpec.vmSize}
                onChange={(event) => {
                  setData({
                    ...data,
                    vcenterSpec: {
                      ...data.vcenterSpec,
                      vmSize: event.target.value,
                    },
                  });
                }}
              >
                <option value="tiny">Tiny</option>
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
                <option value="x-large">X-Large</option>
              </select>
            </cds-select>
            </cds-form-group>
            </div>
          </div>
        </section>



        {/* datastoreSpec */}
        <section className="option_section">
          <span>Datastore Configuration</span>
          <br />
          <cds-select control-width="shrink" validate>
            <label>{`Storage Type`}</label>
            <select
              required
              value={dataStoreType}
              onChange={(event) => {
                setDataStoreType(event.target.value);
              }}
            >
              <option value="" selected={dataStoreType === ""}>
                Select
              </option>
              <option value="vsan" selected={dataStoreType === "vsan"}>
                VSAN
              </option>
              <option value="vmfs" selected={dataStoreType === "vmfs"}>
                VMFS
              </option>
              <option value="nfs" selected={dataStoreType === "nfs"}>
                NFS
              </option>
              <option value="vvol" selected={dataStoreType === "vvol"}>
                VVOL
              </option>
              <br />
            </select>
            <cds-control-message error="valueMissing">required</cds-control-message>
          </cds-select>
          <br />
          {dataStoreType &&
            dataStoreSpecInputs(
              dataStoreType,
              data.computeSpec.clusterSpecs[0].datastoreSpec,
              onDataStoreSpecChange
            )}
        </section>
        {/* networkSpec */}
        {dataStoreType && (
          <div>
            <section className="option_section">
              <b><span>{`Virtual Distributed Switch Configuration`}</span></b>
              <br />
              <cds-select control-width="shrink" validate>
                <label>{`Number Of VDS`}</label>
                <select
                  required
                  value={
                    data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs.length
                  }
                  onChange={(event) => {
                    const noOfVDS = parseInt(event.target.value);
                    if (noOfVDS === 1) {
                      setNoOfVmNics([2, 4, 6]);
                    } else if (noOfVDS === 2) {
                      setNoOfVmNics([4, 6]);
                    } else if (noOfVDS === 3) {
                      setNoOfVmNics([6]);
                    }
                    const vdsSpecs = Array(noOfVDS)
                      .fill()
                      .map((_, i) => {
                        if (i === 0) {
                            return {
                              name: `sfo-w01-cl01-vds0${i + 1}`,
                              isUsedByNsxt: true,
                              portGroupSpecs: genVdsPortGroupSchema(
                                i + 1,
                                dataStoreType === "vsan"
                              ),
                            };
                          } else {
                            return {
                              name: `sfo-w01-cl01-vds0${i + 1}`,
                              portGroupSpecs: [
                                {
                                  name: `sfo-w01-cl01-vds0${i + 1}-pg-public`,
                                  transportType: "PUBLIC",
                                },
                              ],
                          };
                        }
                      });

                    setData({
                      ...data,
                      computeSpec: {
                        ...data.computeSpec,
                        clusterSpecs: [
                          {
                            ...data.computeSpec.clusterSpecs[0],
                            networkSpec: {
                              ...data.computeSpec.clusterSpecs[0].networkSpec,
                              vdsSpecs,
                            },
                          },
                        ],
                      },
                    });
                  }}
                >
                  <option value="">Select</option>
                  {Array(3)
                    .fill()
                    .map((_, i) => {
                      return <option value={i + 1}>{i + 1}</option>;
                    })}
                </select>
                <cds-control-message error="valueMissing">required</cds-control-message>
              </cds-select>
              <br />
              <div className="option_vds_specs">
                {data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs.map(
                  (vdsSpec, i) => {
                    const isVsanChecked =
                      vdsSpec.portGroupSpecs &&
                      vdsSpec.portGroupSpecs.some(
                        (pg) => pg.transportType === "VSAN"
                      );
                      const isVmotionChecked =
                      vdsSpec.portGroupSpecs &&
                      vdsSpec.portGroupSpecs.some(
                        (pg) => pg.transportType === "VMOTION"
                      );
                    return (
                      <div className="option_vds">
                        <span>{`VDS ${i + 1}`}</span>
                        <br />
                        <cds-input layout="horizontal" control-width="shrink" validate>
                          <label>VDS Name</label>
                          <input placeholder={`sfo-w01-cl01-vds0${i + 1}`}
                          required
                          value={vdsSpec.name}
                          onChange={(event) => {
                            onVdsSpecChange(i, "name", event.target.value);
                          }}
                        />
                        <cds-control-message error="valueMissing">required</cds-control-message>
                        </cds-input>
                        <div
                          onChange={(event) => {
                            if (event.target.value === "NSX-T") {
                              onVdsSpecChange(i, "isUsedByNsxt", true);
                            } else if (event.target.value === "VSAN") {
                              onVdsSpecChange(i, "portGroupSpecs", {
                                  name: `sfo-w01-cl01-vds0${i + 1}-pg-vsan`,
                                  transportType: "VSAN",
                                });
                              } else if (event.target.value === "VMOTION") {
                                onVdsSpecChange(i, "portGroupSpecs", {
                                  name: `sfo-w01-cl01-vds0${i + 1}-pg-vmotion`,
                                  transportType: "VMOTION",
                                });
                            }
                          }}
                        >
                          <br></br>
                            <cds-toggle-group layout="vertical-inline">
                            <cds-toggle>
                            <label>NSX-T</label>
                            <input
                              type="checkbox"
                              value="NSX-T"
                              checked={!!vdsSpec.isUsedByNsxt}
                            />{" "}
                            </cds-toggle>
                          {data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs
                          .length > 1 && (
                            <>
                                <cds-toggle>
                                  <label>VMOTION</label>
                                  <input
                                  type="checkbox"
                                  value="VMOTION"
                                  checked={isVmotionChecked}
                                />{" "}
                                </cds-toggle>
                                </>
                              )}
                          {data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs
                            .length > 1 &&
                            dataStoreType === "vsan" && (
                              <>
                                  <cds-toggle>
                                  <label>VSAN</label>
                                  <input
                                  type="checkbox"
                                  value="VSAN"
                                  checked={isVsanChecked}
                                />{" "}
                                </cds-toggle>
                            </>
                          )}
                          </cds-toggle-group>
                          <br></br>
                        </div>
                        {vdsSpec.portGroupSpecs && (
                          <div className="option_vds_portgroup">
                            <span className="option_vds_portgroup_span">
                              Port Groups
                            </span>
                            <br />
                            {vdsSpec.portGroupSpecs.map((portGroupSpec, j) => {
                              let placeholder = "";
                              if (
                                portGroupSpec.transportType === "MANAGEMENT"
                              ) {
                                placeholder = `sfo-w01-cl01-vds0${
                                  i + 1
                                  }-pg-mgmt`;
                              }
                              else if (
                                portGroupSpec.transportType === "VSAN"
                              ) {
                                placeholder = `sfo-w01-cl01-vds0${
                                  i + 1
                                  }-pg-vsan`;
                              } else if (
                                portGroupSpec.transportType === "VMOTION"
                              ) {
                                placeholder = `sfo-w01-cl01-vds0${
                                  i + 1
                                  }-pg-vmotion`;
                              }


                              return (
                                <div className="Option_pg">
                                <cds-form-group layout="vertical" validate>
                                <cds-input >
                                  <label>{`${portGroupSpec.transportType}`}</label>
                                  <input placeholder={placeholder}
                                  required
                                  value={portGroupSpec.name}
                                  onChange={(event) => {
                                    onPortGroupNameChange(
                                      i,
                                      j,
                                      event.target.value
                                    );
                                  }}
                                />
                                <cds-control-message error="valueMissing">required</cds-control-message>
                                </cds-input>
                                </cds-form-group>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            </section>
            <section className="option_section">
              <span className="option_label_text">{`Host TEP Configuration`}</span>
              <br />
              <div cds-layout="horizontal"
                onChange={(event) => {
                  setNsxClusterType(event.target.value);
                }}
              >
                <cds-radio>
                <label>DHCP</label>
                <input
                  type="radio"
                  value="DHCP"
                  name="nsxCluster"
                  checked={nsxClusterType === "DHCP"}
                />
                </cds-radio>
                &nbsp;&nbsp;&nbsp;
                <cds-radio>
                <label>Static with New IP Pool</label>
                <input
                  type="radio"
                  value="static_new"
                  name="nsxCluster"
                  checked={nsxClusterType === "static_new"}
                />
                </cds-radio>
                &nbsp;&nbsp;&nbsp;
                <cds-radio>
                <label>Static with Existing IP Pool</label>
                <input
                  type="radio"
                  value="static_existing"
                  name="nsxCluster"
                  checked={nsxClusterType === "static_existing"}
                />
                </cds-radio>
                <br /><br></br>
              </div>
              <div className="CustomInput">
              <cds-form-group layout="horizontal" validate>
                <cds-input control-width="shrink">
                  <label>{`VLAN ID`}</label>
                  <input
                    required
                    type="number"
                    name="geneveVlanId"
                    value={
                      data.computeSpec.clusterSpecs[0].networkSpec
                        .nsxClusterSpec.nsxTClusterSpec.geneveVlanId
                    }
                    placeholder="0-4095"
                    onChange={onNsxClusterSpecChange}
                  />
                  <cds-control-message error="valueMissing">required</cds-control-message>
                </cds-input>
                </cds-form-group>
              </div>
              <br />
              {nsxTClusterSpecInputs(
                data.computeSpec.clusterSpecs[0].networkSpec.nsxClusterSpec
                  .nsxTClusterSpec.ipAddressPoolSpec,
                onNsxClusterSpecChange
              )}
            </section>
          </div>
        )}
        {/* networkSpec -> hostSpecs */}
        {dataStoreType &&
          data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs.length > 0 && (
            <section className="option_section">
              <span>Host Configuration</span>
              <br />
              <cds-form-group layout="horizontal" validate>
              <cds-select control-width="shrink">
                <label>{`Number of Hosts`}</label>
                <select
                  required
                  value={data.computeSpec.clusterSpecs[0].hostSpecs.length}
                  onChange={(event) => {
                    const noOfHost = parseInt(event.target.value);
                    if (noOfHost === 2) {
                      if (!isClusterImage) {
                        setIsClusterImage(true);
                      }
                    }
                    const defaultHostSpecs = Array(noOfHost)
                      .fill()
                      .map((_, i) => {
                        return {
                          ...hostSpecSchema,
                          hostNetworkSpec: { vmNics: [] },
                        };
                      });

                    setData({
                      ...data,
                      computeSpec: {
                        ...data.computeSpec,
                        clusterSpecs: [
                          {
                            ...data.computeSpec.clusterSpecs[0],
                            hostSpecs: defaultHostSpecs,
                          },
                        ],
                      },
                    });
                  }}
                >
                  <option value="">Select</option>
                  {noOfHostToSelectOptions(noOfHostToSelectStartsWith)}
                </select>
                <cds-control-message error="valueMissing">required</cds-control-message>
              </cds-select>
              {data.computeSpec.clusterSpecs[0].hostSpecs.length > 0 && (
                <>
                  <cds-select control-width="shrink" validate>
                    <label>{`Number of NICs`}</label>
                    <select
                      required
                      value={
                        data.computeSpec.clusterSpecs[0].hostSpecs[0]
                          .hostNetworkSpec.vmNics.length
                      }
                      onChange={(event) => {
                        const vdsNames =
                          data.computeSpec.clusterSpecs[0].networkSpec.vdsSpecs.map(
                            (vdsSpec) => vdsSpec.name
                          );
                        onHostSpecChange(
                          "vmNics",
                          mapVmNicToVds(parseInt(event.target.value), vdsNames)
                        );
                      }}
                    >
                      <option value="">Select</option>
                      {noOfVmNics.map((num) => (
                        <option value={num}>{num}</option>
                      ))}
                    </select>
                    <cds-control-message error="valueMissing">required</cds-control-message>
                  </cds-select>
                  <cds-input layout="horizontal" control-width="shrink" validate>
                    <label>License Key</label>
                    <input placeholder="vsphere_esxi_license_key"
                      required
                      value={
                      data.computeSpec.clusterSpecs[0].hostSpecs[0].licenseKey
                    }
                    onChange={(event) => {
                      onHostSpecChange("licenseKey", event.target.value);
                    }}
                  />
                  <cds-control-message error="valueMissing">required</cds-control-message>
                  </cds-input>
                  <div className="Option_hosts">
                    {data.computeSpec.clusterSpecs[0].hostSpecs.map(
                      (hostSpec, i) => {
                        return (
                          <div className="Option_host">
                            <span>{`ESXi Host ${i + 1}`}</span>
                            <br />
                            <cds-input layout="horizontal" control-width="shrink" validate>
                              <label>ID</label>
                              <input placeholder="guid_of_esxi_host"
                              required
                              value={hostSpec.id}
                              onChange={(event) => {
                                onHostSpecChange("id", event.target.value, i);
                              }}
                            />
                            <cds-control-message error="valueMissing">required</cds-control-message>
                            </cds-input>
                          </div>
                        );
                      }
                    )}
                  </div>
                </>
              )}
             </cds-form-group>
            </section>
          )}
        <section className="option_section">
          <span>{`Create new NSX-T infrastructure? `}</span>
          <br />
          <div className="Option_infrastructure">
            <div cds-layout="horizontal"
              onChange={(event) => {
                setIsNewNsxTSpec(event.target.value);
              }}
            >
              <cds-radio>
                <label>Yes</label>
              <input type="radio" value="Yes" name="isNewNsxTSpec" />
              </cds-radio>
              &nbsp;&nbsp;&nbsp;
              <cds-radio>
                <label>No</label>
              <input type="radio" value="No" name="isNewNsxTSpec" />
              </cds-radio>
            </div>
            {isNewNsxTSpec === "No" && (
              <><br></br><b><br></br>
                <span className="Option_infrastructure_underline">{`Please enter the information for the existing NSX-T infrastructure info!`}</span>
              </b><br /><br></br>
              </>
            )}
          </div>
          <br></br><br></br>
          {isNewNsxTSpec !== "Not Selected" && (
            <>
              <span>{`NSX-T Configuration`}</span><br></br>
              <div className="option_clusterspec_div">
              <cds-form-group layout="horizontal" validate>
                <cds-input layout="horizontal" control-width="shrink">
                  <label>VIP Address</label>
                  <input placeholder="172.16.11.75"
                  required
                  pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
                  value={data.nsxTSpec.vip}
                  onChange={(event) =>
                    setData({
                      ...data,
                      nsxTSpec: {
                        ...data.nsxTSpec,
                        vip: event.target.value,
                      },
                    })
                  }
                />
                <cds-control-message error="valueMissing">required</cds-control-message>
                </cds-input>
               <cds-input layout="horizontal" control-width="shrink">
                  <label>VIP FQDN</label>
                  <input placeholder="sfo-w01-nsx01.sfo.rainpole.io"
                  required
                  value={data.nsxTSpec.vipFqdn}
                  onChange={(event) =>
                    setData({
                      ...data,
                      nsxTSpec: {
                        ...data.nsxTSpec,
                        vipFqdn: event.target.value,
                      },
                    })
                  }
                />
                <cds-control-message error="valueMissing">required</cds-control-message>
                </cds-input>
                <cds-input layout="horizontal" control-width="shrink">
                  <label>License Key</label>
                  <input placeholder="nsxt_datacenter_enterprise_license_key"
                  required
                  value={data.nsxTSpec.licenseKey}
                  onChange={(event) =>
                    setData({
                      ...data,
                      nsxTSpec: {
                        ...data.nsxTSpec,
                        licenseKey: event.target.value,
                      },
                    })
                  }
                />
                <cds-control-message error="valueMissing">required</cds-control-message>
                </cds-input>
                <cds-input layout="horizontal" control-width="shrink">
                  <label>Admin Password</label>
                  <input placeholder="nsxt_manager_admin_password"
                  required
                  value={data.nsxTSpec.nsxManagerAdminPassword}
                  onChange={(event) =>
                    setData({
                      ...data,
                      nsxTSpec: {
                        ...data.nsxTSpec,
                        nsxManagerAdminPassword: event.target.value,
                      },
                    })
                  }
                />
                <cds-control-message error="valueMissing">required</cds-control-message>
                </cds-input>
                <cds-select control-width="shrink">
                  <label>VM Size </label>
                  <select
                    value={data.nsxTSpec.formFactor}
                    onChange={(event) => {
                      setData({
                        ...data,
                        nsxTSpec: {
                          ...data.nsxTSpec,
                          formFactor: event.target.value,
                        },
                      });
                    }}
                  >
                    <option value="x-small">Extra Small</option>
                    <option value="small">Small</option>
                    <option value="medium">Medium</option>
                    <option value="large">Large</option>
                  </select>
                </cds-select>
                </cds-form-group>
                <br></br>
              </div>
              <br />
              <span>{`NSX-T Manager Configuration`}</span>
              <br></br>
              <div className="Option_nsxt_manager_specs">
                {data.nsxTSpec.nsxManagerSpecs.map((nsxManagerSpec, i) => {
                  let namePlaceholder = "";
                  let ipAddressPlaceholder = "";
                  let dnsNamePlaceholder = "";
                  if (i === 0) {
                    namePlaceholder = "sfo-w01-nsx01a";
                    ipAddressPlaceholder = "172.16.11.76";
                    dnsNamePlaceholder = "sfo-w01-nsx01a.sfo.rainpole.io";
                  } else if (i === 1) {
                    namePlaceholder = "sfo-w01-nsx01b";
                    ipAddressPlaceholder = "172.16.11.77";
                    dnsNamePlaceholder = "sfo-w01-nsx01b.sfo.rainpole.io";
                  } else if (i === 2) {
                    namePlaceholder = "sfo-w01-nsx01c";
                    ipAddressPlaceholder = "172.16.11.78";
                    dnsNamePlaceholder = "sfo-w01-nsx01c.sfo.rainpole.io";
                  }
                  return (
                    <div className="Option_NsxtManager">
                      <span>{`NSX-T Manager ${i + 1}`}</span>
                      <br />
                      <cds-form-group layout="horizontal" validate>
                      <cds-input layout="horizontal" control-width="shrink">
                        <label>VM Name</label>
                        <input placeholder={namePlaceholder}
                        required
                        value={nsxManagerSpec.name}
                        onChange={(event) =>
                          onNsxManagerSpecChange(i, "name", event.target.value)
                        }
                      />
                      <cds-control-message error="valueMissing">required</cds-control-message>
                      </cds-input>
                      <cds-input layout="horizontal" control-width="shrink">
                        <label>IP Address</label>
                        <input placeholder={ipAddressPlaceholder}
                        required
                        pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
                        value={nsxManagerSpec.networkDetailsSpec.ipAddress}
                        onChange={(event) =>
                          onNsxManagerSpecChange(
                            i,
                            "ipAddress",
                            event.target.value
                          )
                        }
                      />
                      <cds-control-message error="valueMissing">required</cds-control-message>
                      </cds-input>
                      <cds-input layout="horizontal" control-width="shrink">
                        <label>FQDN</label>
                        <input placeholder={dnsNamePlaceholder}
                        required
                        value={nsxManagerSpec.networkDetailsSpec.dnsName}
                        onChange={(event) =>
                          onNsxManagerSpecChange(
                            i,
                            "dnsName",
                            event.target.value
                          )
                        }
                      />
                      <cds-control-message error="valueMissing">required</cds-control-message>
                      </cds-input>
                      <cds-input layout="horizontal" control-width="shrink">
                        <label>Gateway</label>
                        <input placeholder="172.16.11.1"
                        required
                        pattern="^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])"
                        value={nsxManagerSpec.networkDetailsSpec.gateway}
                        onChange={(event) =>
                          onNsxManagerSpecChange(
                            i,
                            "gateway",
                            event.target.value
                          )
                        }
                      />
                      <cds-control-message error="valueMissing">required</cds-control-message>
                      </cds-input>
                      <cds-input layout="horizontal" control-width="shrink">
                        <label>Subnet Mask</label>
                        <input placeholder="255.255.255.0"
                        required
                        pattern="^(((255\.){3}(255|254|252|248|240|224|192|128|0+))|((255\.){2}(255|254|252|248|240|224|192|128|0+)\.0)|((255\.)(255|254|252|248|240|224|192|128|0+)(\.0+){2})|((255|254|252|248|240|224|192|128|0+)(\.0+){3}))"
                        value={nsxManagerSpec.networkDetailsSpec.subnetMask}
                        onChange={(event) =>
                          onNsxManagerSpecChange(
                            i,
                            "subnetMask",
                            event.target.value
                          )
                        }
                      />
                      <cds-control-message error="valueMissing">required</cds-control-message>
                      </cds-input>
                      </cds-form-group>
                    </div>
                  );
                })}
              </div>
              <br />
            </>
          )}
        </section>
        <CdsButton
            action="solid"
            size="md"
            type="button"
            className="download_button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              eventTrack.bind(this, "Download Button", "Download"); exportJSON(data, 1);
            }}
          >
            <span className="download_button_text">Download JSON</span>
            <CdsIcon shape="download"></CdsIcon>
          </CdsButton><br />
          <div className="beer_button"><Coffee /></div>
        </div>
        <div className="option_json_preview">
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
      </div>
    </form>
  );
}